<script setup>

import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "controlesDesativados",
    "cancelandoDado",
    "dadoOriginal",
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraCancelandoDado",
]);

//==================================================================//
//============================= Dado ===============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//================ Loaded Altera Controles Desativos ===============//
//==================================================================//

const alteraControlesDesativados = (update = false) =>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//==================== Altera Cancelando Dado ======================//
//==================================================================//

const alteraCancelandoDado = () =>{

    emits('update:alteraCancelandoDado');

};

//==================================================================//
//========================= Fecha Modal ============================//
//==================================================================//

const fechaModal = () =>{

    alteraCancelandoDado();

};

//==================================================================//
//==================== Altera Dado de Compra =======================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value, update)

};

//===================================================================//
//========================== Prepara Dado ===========================//
//=================================================-=================//

const preparaDado = (dado = {})=>{

    let itens = dado?.itens?.map((item)=>{

        let subItens = item?.itens?.map((subItem)=>{

            return{
                id: subItem?.id || "",
                codigo: subItem?.codigo || "",
                sequencia: subItem?.sequencia || "",
                descricao: subItem?.descricao || "",
                quantidade: subItem?.quantidade || 0,
                valorUnitario: subItem?.valorUnitario || 0,
                valorTotal: subItem?.valorTotal || 0,
            };

        });

        return{
            id: item?.id || "",
            aberto: false,
            codigo: item?.codigo || "",
            status: item?.status || "",
            sequencia: item?.sequencia || "",
            descricao: item?.descricao || "",
            dataPrazoEntrega: item?.dataPrazoEntrega || "",
            dataPrazoEntregaFormatada: item?.dataPrazoEntregaFormatada || "",
            quantidade: item?.quantidade || 0,
            precoUnitario: item?.precoUnitario || 0,
            precoTotal: item?.precoTotal || 0,
            valorBaseICMS_ISS: item?.valorBaseICMS_ISS || 0,
            porcentagemICMS: item?.porcentagemICMS || 0,
            valorICMS: item?.valorICMS || 0,
            porcentagemIPI: item?.porcentagemIPI || 0,
            valorIPI: item?.valorIPI || 0,
            porcentagemISS: item?.porcentagemISS || 0,
            valorISS: item?.valorISS || 0,
            ncm: item?.ncm || {},
            //tipoDeEquipamento: item?.tipoDeEquipamento || {},
            tipoDeEquipamentoID: item?.tipoDeEquipamento?.id || "",
            tipoDeEquipamentoCodigo: item?.tipoDeEquipamento?.codigo || "",
            tipoDeEquipamentoDescricao: item?.tipoDeEquipamento?.descricao || "",
            itens: subItens || [],
            itensQuantidade: item?.itensQuantidade || 0,
        }

    });

    let aditivos = dado?.aditivos?.map((aditivo)=>{

        return{
            id: aditivo?.id || "",
            codigo: aditivo?.codigo || "",
            descricao: aditivo?.descricao || "",
            valorAdicional: aditivo?.valorAdicional || 0,
        }

    });
    
    dado = {
        id: dado?.id || "",
        status: dado?.status || "",
        codigo: dado?.codigo || "",
        jobTipo: dado?.jobTipo || "",
        
        valorDeCusto: dado?.valorDeCusto || 0,
        valorDeVenda: dado?.valorDeVenda || 0,
        valorDeVendaComImpostos: dado?.valorDeVendaComImpostos || 0,

        descricao: dado?.descricao || "",
        condicaoDePagamento: dado?.condicaoDePagamento || "",
        observacao: dado?.observacao || "",
        justificativaDeCancelamento: dado?.justificativaDeCancelamento || "",

        dataAbertura: dado?.dataAbertura || "",
        dataAberturaFormatada: dado?.dataAberturaFormatada || "",
        
        dataEntregaContratual: dado?.dataEntregaContratual || "",
        dataEntregaContratualFormatada: dado?.dataEntregaContratualFormatada || "",
        dataEncerramento: dado?.dataEncerramento || "",
        dataEncerramentoFormatada: dado?.dataEncerramentoFormatada || "",
        
        dataEnvioAprovacaoContratual: dado?.dataEnvioAprovacaoContratual || "",
        dataEnvioAprovacaoContratualFormatada: dado?.dataEnvioAprovacaoContratualFormatada || "",
        dataEnvioAprovacaoEfetiva: dado?.dataEnvioAprovacaoEfetiva || "",
        dataEnvioAprovacaoEfetivaFormatada: dado?.dataEnvioAprovacaoEfetivaFormatada || "",
        naoTemEnvioAprovacao: dado?.naoTemEnvioAprovacao || "",
        
        dataAprovacaoPrevista: dado?.dataAprovacaoPrevista || "",
        dataAprovacaoPrevistaFormatada: dado?.dataAprovacaoPrevistaFormatada || "",
        dataAprovacaoEfetiva: dado?.dataAprovacaoEfetiva || "",
        dataAprovacaoEfetivaFormatada: dado?.dataAprovacaoEfetivaFormatada || "",
        naoTemAprovacao: dado?.naoTemAprovacao || false,
       
        dataInspecaoPrevista: dado?.dataInspecaoPrevista || "",
        dataInspecaoPrevistaFormatada: dado?.dataInspecaoPrevistaFormatada || "",
        dataInspecaoEfetiva: dado?.dataInspecaoEfetiva || "",
        dataInspecaoEfetivaFormatada: dado?.dataInspecaoEfetivaFormatada || "",
        naoTemInspecao: dado?.naoTemInspecao || false,
        
        dataEntregaFiscalPrevista: dado?.dataEntregaFiscalPrevista || "",
        dataEntregaFiscalPrevistaFormatada: dado?.dataEntregaFiscalPrevistaFormatada || "",
        dataEntregaFiscalEfetiva: dado?.dataEntregaFiscalEfetiva || "",
        dataEntregaFiscalEfetivaFormatada: dado?.dataEntregaFiscalEfetivaFormatada || "",
        naoTemEntregaFiscal: dado?.naoTemEntregaFiscal || false,
        
        dataMontagemContratual: dado?.dataMontagemContratual || "",
        dataMontagemContratualFormatada: dado?.dataMontagemContratualFormatada || "",
        dataMontagemEfetiva: dado?.dataMontagemEfetiva || "",
        dataMontagemEfetivaFormatada: dado?.dataMontagemEfetivaFormatada || "",
        naoTemMontagem: dado?.naoTemMontagem || false,

        dataStartupPrevista: dado?.dataStartupPrevista || "",
        dataStartupPrevistaFormatada: dado?.dataStartupPrevistaFormatada || "",
        dataStartupEfetiva: dado?.dataStartupEfetiva || "",
        dataStartupEfetivaFormatada: dado?.dataStartupEfetivaFormatada || "",
        naoTemStartup: dado?.naoTemStartup || false,

        dataFinalContratual: dado?.dataFinalContratual || "",
        dataFinalContratualFormatada: dado?.dataFinalContratualFormatada || "",
        dataFinalEfetiva: dado?.dataFinalEfetiva || "",
        dataFinalEfetivaFormatada: dado?.dataFinalEfetivaFormatada || "",

        solicitacaoDeOrcamento: dado?.solicitacaoDeOrcamento || {},
        solicitacaoDeOrcamentoID: dado?.solicitacaoDeOrcamento?.id || "",
        solicitacaoDeOrcamentoCodigo: dado?.solicitacaoDeOrcamento?.codigo || "",
        solicitacaoDeOrcamentoValor: dado?.solicitacaoDeOrcamento?.valor || "",

        //solicitacaoDeOrcamentoTipoDeEquipamento: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoID: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.id || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoSigla: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.sigla || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoDescricao: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.descricao || "",

        //solicitacaoDeOrcamentoContatoComercial: dado?.solicitacaoDeOrcamento?.contatoComercial || {},
        solicitacaoDeOrcamentoContatoComercialID: dado?.solicitacaoDeOrcamento?.contatoComercial?.id || "",
        solicitacaoDeOrcamentoContatoComercialTipo: dado?.solicitacaoDeOrcamento?.contatoComercial?.tipo || "",
        solicitacaoDeOrcamentoContatoComercialNome: dado?.solicitacaoDeOrcamento?.contatoComercial?.nome || "",

        //solicitacaoDeOrcamentoContatoTecnico: dado?.solicitacaoDeOrcamento?.contatoTecnico || {},
        solicitacaoDeOrcamentoContatoTecnicoID: dado?.solicitacaoDeOrcamento?.contatoTecnico?.id || "",
        solicitacaoDeOrcamentoContatoTecnicoTipo: dado?.solicitacaoDeOrcamento?.contatoTecnico?.tipo || "",
        solicitacaoDeOrcamentoContatoTecnicoNome: dado?.solicitacaoDeOrcamento?.contatoTecnico?.nome || "",

        cliente: dado?.cliente || {},
        clienteID: dado?.cliente?.id || "",
        clienteCodigo: dado?.cliente?.codigo || "",
        clienteNome: dado?.cliente?.nomeFantasia || "",
        clientePedidoDeCompra: dado?.clientePedidoDeCompra || "",
        clienteEmailXML: dado?.clienteEmailXML || "",

        //comercial : dado?.comercial || {},
        comercialID: dado?.comercial?.id || "",
        comercialCodigo: dado?.comercial?.codigo || "",
        comercialNome: dado?.comercial?.nome || "",

        //gestor: dado?.gestorDeContratos || {},
        gestorID: dado?.gestorDeContratos?.id || "",
        gestorCodigo: dado?.gestorDeContratos?.codigo || "",
        gestorNome: dado?.gestorDeContratos?.nome || "",

        //coordenador: dado?.coordenadorDeContratos || {},
        coordenadorID: dado?.coordenadorDeContratos?.id || "",
        coordenadorCodigo: dado?.coordenadorDeContratos?.codigo || "",
        coordenadorNome: dado?.coordenadorDeContratos?.nome || "",

        //ncm: dado?.ncm || {},
        ncmID: dado?.ncm?.id || "",
        ncmCodigo: dado?.ncm?.codigo || "",
        ncmDescricao: dado?.ncm?.descricao || "",
        ncmDescricaoCompleta: dado?.ncm?.descricaoCompleta || "",

        //transporte: dado?.transporte || {},
        transporteID: dado?.transporte?.id || "",
        transporteCodigo: dado?.transporte?.codigo || "",
        transporteOrdem: dado?.transporte?.ordem || "",
        transporteSigla: dado?.transporte?.sigla || "",
        transporteDescricao: dado?.transporte?.descricao || "",
        transporteDescricaoCompleta: dado?.transporte?.descricaoCompleta || "",

        itens: itens || [],
        itensQuantidade: dado?.itensQuantidade || 0,

        aditivos: aditivos || [],
        aditivosQuantidade : dado?.aditivosQuantidade || 0,
    }

    alteraDado(dado);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = ()=>{

    preparaDado(UtilObject.clone(props?.dadoOriginal));

}

//====================================================================//
//==== Prepara Modal se Dados Originais Carregados ou Recarregados ===//
//===================== Watch => cancelandoDado ======================//
//====================================================================//

watch(()=> props?.cancelandoDado, () => {

    if(props?.cancelandoDado == true){
        preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.cancelandoDado"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="dado"
                    :cancelandoDado="props.cancelandoDado"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:fechaModal="fechaModal"
                ></BarraNavegacao>

                <DadoConteudo
                    :dado="dado"
                    @update:alteraDado="alteraDado"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>